import React from 'react';
import { Box, Typography, Card, CardActionArea, CardContent, Stack } from '@mui/material';
import type { Candidate } from '@components/ui/dashboard/ApplicantReview/types/candidate';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './CandidateSidebar.translations.json';
type SupportedLanguage = keyof typeof translations;

interface CandidateSidebarProps {
  candidates: Candidate[];
  selectedId: string | null;
  onSelectCandidate: (id: string) => void;
}

export const CandidateSidebar: React.FC<CandidateSidebarProps> = ({
  candidates,
  selectedId,
  onSelectCandidate,
}) => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;
  return (
    <Box
      sx={{
        width: 320,
        borderRight: '1px solid #23262d',
        p: 3,
        height: '100vh',
        boxSizing: 'border-box',
        overflowY: 'auto',
      }}
    >
      <Typography variant="caption" sx={{ color: '#6C727F', letterSpacing: 1.2, fontWeight: 700 }}>
        {content.workspace}
      </Typography>
      <Typography variant="h5" fontWeight="bold" color="#FFFFFF" mt={1}>
        {content.candidates}
      </Typography>
      <Typography variant="body2" color="#6C727F" mb={3}>
        {candidates.length} {content.applications}
      </Typography>

      <Stack spacing={2}>
        {candidates.map((candidate) => {
          const isSelected = candidate.id === selectedId;
          return (
            <Card
              key={candidate.id}
              elevation={0}
              sx={{
                backgroundColor: isSelected ? '#1A1C23' : '#121316',
                border: isSelected ? '1px solid #0a66c2' : '1px solid #23262d',
                borderRadius: 2,
                transition: 'all 0.2s ease',
              }}
            >
              <CardActionArea onClick={() => onSelectCandidate(candidate.id)} sx={{ p: 0.5 }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold" color="#FFFFFF">
                    {candidate.name}
                  </Typography>
                  <Typography variant="caption" color="#8C939D">
                    {candidate.role}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })}
      </Stack>
    </Box>
  );
};